import './ButtonClose.scss';

import cn from 'classnames';
import React, { cloneElement, useMemo } from 'react';

import { ReactComponent as CloseIcon } from '@/common/assets/icons/close.svg';
import Button from '@/common/components/atoms/Button/Button';
import {
  ButtonCloseDefaultProps,
  ButtonClosePropTypes,
} from '@/common/components/molecules/ButtonClose/ButtonClose.proptypes';

const ButtonClose = ({
  animHover,
  className,
  context,
  disabled,
  display,
  icon,
  id,
  onClick,
  reversed,
  title,
}) => {
  const Icon = useMemo(() => {
    if (icon) {
      return cloneElement(icon, {
        className: 'button-close__icon',
      });
    }

    return <CloseIcon className="button-close__icon" />;
  }, [icon]);

  const conditionalProps = useMemo(
    () => ({
      ...(id ? { id } : {}),
      ...(context ? { context } : { context: 'close' }),
    }),
    [context, id],
  );

  return (
    <Button
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...conditionalProps}
      aria-disabled={disabled}
      className={cn('button-close', className, {
        'button-close--anim-hover': animHover,
        'button-close--reversed': reversed,
      })}
      disabled={disabled}
      display={display}
      onClick={onClick}
      reversed={reversed}
      title={title}
    >
      {Icon}
    </Button>
  );
};

ButtonClose.defaultProps = {
  ...ButtonCloseDefaultProps,
};

ButtonClose.propTypes = {
  ...ButtonClosePropTypes,
};

export default ButtonClose;
